const state = () => ({
  dialogFrom: null
});

const getters = {
  dialogFrom(state) {
    return state.dialogFrom;
  }
};

const mutations = {
  updateDialogFrom(state, payload) {
    state.dialogFrom = payload;
  }
};

export const dialogPage = {
  state,
  getters,
  mutations,
  namespaced: true
};
